import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Figure from "react-bootstrap/Figure";
import Image from "react-bootstrap/Image";
import profile_pic from "./Profile.jpeg"; // with import
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./header.module.css";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

function Header() {
  // Declare a new state variable, which we'll call "count"
  const [count, setCount] = useState(0);
  const classes = useStyles();


  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
}

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      className={styles.header_container}
    >
      <Grid item xs={6}>
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid item>
            <h1>Vivek Mathur</h1>
          </Grid>

          <Grid item>
                  <p>
                    I'm a college student at Tufts university majoring in
                    Computer Science. I'm a very active part of the CS community
                    at Tufts and love turning my ideas into life through code. I
                    like playing the violin and hanging out with my friends in
                    my free time.
                  </p>
          </Grid>

          <Grid item>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              spacing={3}
            >
              <Grid item>
                <button className={styles.myButton}
                onClick={event =>  openInNewTab("https://github.com/vivekmthr/")}>
                  <img src="https://img.icons8.com/material-sharp/24/000000/github.png" />{" "}
                  Github
                </button>
              </Grid>

              <Grid item>
                <button className={styles.myButton}
                onClick={event =>  openInNewTab("https://www.linkedin.com/in/vivek-mathur-a077ab164/")}>
                  <img src="https://img.icons8.com/fluent/24/000000/linkedin.png" />{" "}
                  Linkedin
                </button>
              </Grid>

              <Grid item>
                <button className={styles.myButton}
                                onClick={event =>  openInNewTab("https://1drv.ms/b/s!AjnMmR_5pp5ghpI6VjxrVqSbtpWfOg")}
                >
                  <img src="https://img.icons8.com/offices/30/000000/open-resume.png" />{" "}
                  Resume
                </button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={6}>
        <Grid container direction="row" justify="center" alignItems="center">
          <Image className={styles.profile_pic} src={profile_pic} circle fluid />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Header;
